// Collection cards are wrapped in a link to the product page. A plain click
// on the tooltip's <summary> would both toggle the <details> (native default
// action) AND bubble up to trigger that link's navigation (a separate native
// default action on the same event) -- preventDefault() suppresses both, so
// the toggle is done manually here instead of relying on the native one.
document.addEventListener(
  'click',
  function (evt) {
    var summary = evt.target.closest('.pack-size-help__icon');
    if (!summary) return;
    evt.preventDefault();
    evt.stopPropagation();
    var details = summary.closest('.pack-size-help');
    if (!details) return;
    var willOpen = !details.open;
    document.querySelectorAll('.pack-size-help[open]').forEach(function (el) {
      el.removeAttribute('open');
    });
    if (willOpen) details.setAttribute('open', '');
  },
  true
);

// Closes any open tooltip when clicking anywhere outside it.
document.addEventListener('click', function (evt) {
  document.querySelectorAll('.pack-size-help[open]').forEach(function (el) {
    if (!el.contains(evt.target)) el.removeAttribute('open');
  });
});
